<template>
  <va-show :item="item">
    <va-field source="request"></va-field>
    <va-field source="answer"></va-field>
  </va-show>
</template>

<script>
export default {
  props: ["item"],
};
</script>
